var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-dropdown",
        {
          staticClass: "float-right mb-2",
          attrs: {
            id: "dropdown-save-selection-as",
            text: "Save:",
            "toggle-class": "btn-primary",
            variant: "primary",
            size: "sm",
          },
        },
        [
          _c("b-dropdown-item", { attrs: { id: "saveToolChangesBtn" } }, [
            _vm._v("\n      Update Template...\n    "),
          ]),
          _vm._v(" "),
          !_vm.themeSelected
            ? _c(
                "b-dropdown-item",
                {
                  staticClass: "warning",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.warnIfNoThemeSelected.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v("\n      As theme image\n      "),
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v("please select theme"),
                  ]),
                ]
              )
            : _vm.isSavableToTheme
            ? _c(
                "b-dropdown-item",
                {
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.saveToTheme.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n      As theme image\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("b-dropdown-item", { on: { click: _vm.uploadToFileBrowser } }, [
            _vm._v("\n      File Browser...\n    "),
          ]),
          _vm._v(" "),
          _vm.isDownloadable
            ? _c(
                "b-dropdown-item",
                {
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.downloadFromBrowser.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n      Download\n    ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showFilenamePrompt
        ? _c("div", { staticClass: "custom-popup" }, [
            _c(
              "div",
              { staticClass: "custom-popup-content" },
              [
                _c("h5", [_vm._v("Enter File Name")]),
                _vm._v(" "),
                _c("b-form-input", {
                  attrs: { placeholder: "Enter filename..." },
                  model: {
                    value: _vm.tempFileName,
                    callback: function ($$v) {
                      _vm.tempFileName = $$v
                    },
                    expression: "tempFileName",
                  },
                }),
                _vm._v(" "),
                _c(
                  "b-form-checkbox",
                  {
                    staticClass: "mt-2 d-none",
                    model: {
                      value: _vm.replaceExistingImage,
                      callback: function ($$v) {
                        _vm.replaceExistingImage = $$v
                      },
                      expression: "replaceExistingImage",
                    },
                  },
                  [_vm._v("\n        Replace existing image\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-3 d-flex justify-content-end" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "mr-2",
                        attrs: { variant: "secondary" },
                        on: { click: _vm.cancelFileName },
                      },
                      [_vm._v("\n          Cancel\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "primary",
                          disabled: !_vm.tempFileName.trim(),
                        },
                        on: { click: _vm.confirmFileName },
                      },
                      [_vm._v("\n          OK\n        ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "custom-popup-backdrop" }),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }